import { Box, Divider } from '@mui/material'
import { useEffect, useContext, useRef } from 'react'

import { LogDataContext } from 'src/store/logs/Store'

import LogEntry from 'src/components/common/LogEntry'
import Cinematic from './Cinematic'
import { hideScrollbarX, hideScrollbarY } from 'src/utils/cssStyles'

const container = {
  fontSize: '20px',
  marginY: '16px',
  width: '100%',
  maxWidth: '100%',
  maxHeight: '15vh',
  backgroundColor: 'black',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-end',
  ...hideScrollbarY,
  ...hideScrollbarX
}

const cinematicWrapper = {
  position: 'relative',
  height: '256px',
  width: '100%',
  transform: 'scale(calc(100vw - 256px))'
}

const Logs = () => {
  const { logs } = useContext(LogDataContext)

  // scroll to end when new logs come in
  const logsEndRef = useRef(null)
  useEffect(() => {
    if (logsEndRef.current) {
      // @ts-expect-error
      logsEndRef.current.scrollIntoView({ behavior: 'smooth', block: 'end'})
    }
  }, [logs.length])

  // development build logs
  useEffect(() => {
    if (process.env.REACT_APP_BENCHMARK === 'true') { console.log('Logs mounted') }
    return process.env.REACT_APP_BENCHMARK === 'true' ? () => console.log('Logs unmounted') : () => {}
  }, [])

  return (
    <Box sx={container} className="logs">
      {logs.map((log, index) => (
        <Box key={index} sx={{marginTop: '4px'}}>
          { log.spriteID ? (
            <Box sx={cinematicWrapper} className='cinematic-wrapper'>
              { log.spriteID ? (
                <Cinematic spriteID={log.spriteID}/>
              ) : null }
            </Box>
          ) : null
        }
          <LogEntry
            key={index}
            log={log}
          />
        </Box>
      ))}
      <Divider ref={logsEndRef} sx={{ paddingTop: '16px', width: '100%', maxWidth: '100%' }}/>
    </Box>
  )
}

export default Logs
